import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/context/SmoothScroll";
import MarketingLayout from "@/layouts/MarketingLayout";
import Home from "@/pages/Home";
import Drops from "@/pages/Drops";
import Strains from "@/pages/Strains";
import StrainDetail from "@/pages/StrainDetail";
import TapIn from "@/pages/TapIn";
import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

function RedirectBlogStrain() {
  const { slug } = useParams();
  return <Navigate to={`/strains/${slug}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SmoothScroll>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/drops" element={<Drops />} />
              <Route path="/strains" element={<Strains />} />
              <Route path="/strains/:slug" element={<StrainDetail />} />
              <Route path="/tap-in" element={<TapIn />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

            {/* 301-style redirects from old Shopify paths */}
            <Route path="/collections/all-products" element={<Navigate to="/drops" replace />} />
            <Route path="/blogs/2026-strains" element={<Navigate to="/strains" replace />} />
            <Route path="/blogs/2026-strains/:slug" element={<RedirectBlogStrain />} />
            <Route path="/pages/contact" element={<Navigate to="/tap-in" replace />} />
            <Route path="/cart" element={<Navigate to="/drops" replace />} />
            <Route path="/checkout" element={<Navigate to="/drops" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SmoothScroll>
        <Toaster position="top-center" theme="dark" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
